import React from 'react'
import { GetIconColor } from './theme/main_style'
import { ItemIcon } from './components/IconComponent'

const valueType = {
    string: 'string',
    amount: 'amount',
    date: 'date',
    datetime: 'datetime'
}

const align = {
    left: 'left',
    right: 'right',
    center: 'center'
}
const component = {
    badge: 'badge',
    text: 'text' //default
}
const actionType = {
    func: 'func',
    redirect: 'redirect' //default
}

export const installationsTableConfig = [
    { key: 'number', label: "number", type: valueType.string, align: align.left, sort: false, action: false },
    { key: 'contact.name', label: "contact", type: valueType.string, align: align.left, sort: false, action: false },
    { key: 'key_dates.submitted_on', label: 'date', type: valueType.datetime, align: align.left, sort: false, action: false },
    {
        key: 'stage.name', label: 'order_stage', type: valueType.string, component: component.badge, align: align.left, sort: false, action: false, mappingValue: true,
        badgeConfig: {
            stylesConfig: {
                "Completed": 'success',
                "Paid - Pending scheduling": "custom3"
            }
        }
    },
    {
        key: 'state', label: 'order_status', type: valueType.string, component: component.badge, align: align.left, sort: false, action: false, mappingValue: true,
        badgeConfig: {
            stylesConfig: {
                COMPLETED: 'success',
                CANCELLED: 'error',
                NEW: 'info',
                IN_PROGRESS: 'warning'
            }
        }
    },
]

export const activitiesTableConfig = [
    { key: 'activity_number', label: "activity_number", type: valueType.string, align: align.left, sort: false, action: false },
    { key: 'name', label: "activity_name", type: valueType.string, align: align.left, sort: false, action: false },
    { key: 'type.name', label: "type", type: valueType.string, align: align.left, sort: false, action: false },
    { key: 'order.number', label: "order_number", type: valueType.string, align: align.left, sort: false, action: false },
    { key: 'contact.name', label: "contact", type: valueType.string, align: align.left, sort: false, action: false },
    { key: 'address.town_city', label: "city", type: valueType.string, align: align.left, sort: false, action: false },
    { key: 'created_date', label: 'created_date', type: valueType.date, align: align.left, sort: false, action: false },
    { key: 'date', label: 'scheduled_date', type: valueType.date, align: align.left, sort: false, action: false },
    { key: 'status', label: 'status', type: valueType.string, component: component.badge, align: align.left, sort: false, action: false },
    {
        key: 'state', label: 'state', type: valueType.string, component: component.badge, align: align.left, sort: false, action: false, mappingValue: true,
        badgeConfig: {
            stylesConfig: {
                COMPLETED: 'success',
                CANCELLED: 'error',
                NEW: 'info',
                PENDING: 'warning',
            }
        }
    },
]

